import { useTasks } from "../Tasks";

const Complete = ({ id, complete, pushed }) => {
  const { todaysDate, markComplete } = useTasks();

  const done = () => {
    markComplete(id);
  };

  if (pushed <= todaysDate && complete === false) {
    return (
      <button className="btn complete-btn" onClick={done}>
        Complete
      </button>
    );
  } else {
    return null;
  }
};

export default Complete;
